// extracted by mini-css-extract-plugin
export var backdropBlur = "_c4-0";
export var contentCard = "_c4-5";
export var frame = "_c4-2";
export var image = "_c4-4";
export var imagePane = "_c4-3";
export var modal = "_c4-1";